'use es6';

import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const SENDERS_FETCH = createAsyncActionTypes('SENDERS_FETCH');